<template>

  <div class="language-selector">
    <span :class="{ bold: lang === 'us' }" @click="onChange('us')">EN</span>
    <span>|</span>
    <span :class="{ bold: lang === 'vn' }" @click="onChange('vn')">VN</span>
  </div>
</template>

<script>
import { useCookies } from "vue3-cookies"
import { LANGUAGE, DEFAULT } from '@/const/language'
import store from '@/store/index'
import { createApp } from 'vue'
import { useI18n } from "vue-i18n"
import serviceData from '@/services/servicesApi'
export default {
  setup() {
    const { cookies } = useCookies()
    const app = createApp({})
    let lang_cookie = cookies.get(LANGUAGE)
    if (lang_cookie == null || lang_cookie == undefined) {
      cookies.set(LANGUAGE, DEFAULT)
    } else {
      cookies.set(LANGUAGE, lang_cookie)
    }

    const { t } = useI18n()
    return { cookies, app, serviceData, t }
  },
  data() {
    return {
      lang: DEFAULT,
    }
  },
  mounted() {
    this.$i18n.locale = this.cookies.get(LANGUAGE)
    this.lang = this.cookies.get(LANGUAGE)
  },
  methods: {
    onChange(langChange) {
      store.dispatch('setCountryChange', langChange)
      localStorage.setItem(LANGUAGE, langChange)
      this.cookies.set(LANGUAGE, langChange)
      this._lenguage = langChange
      this.$i18n.locale = langChange
      this.lang = langChange
    }
  }
}
</script>

<style scoped>
.item-flag {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flag:hover {
  cursor: pointer;
}
</style>
